
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.5","height":"16.5"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_42863","data-name":"Group 42863","transform":"translate(-860.598 -12.25)"}},[_c('path',{attrs:{"id":"Path_29661","data-name":"Path 29661","d":"M876.348 22.191a1.655 1.655 0 01-1.654 1.652h-1.335v3.115A1.042 1.042 0 01872.317 28h-3.308v-1.355a1.656 1.656 0 00-3.311 0V28h-3.31a1.041 1.041 0 01-1.04-1.042v-3.115h1.193a1.652 1.652 0 00.077-3.3h-1.27v-3.496a1.041 1.041 0 011.04-1.042h3.31v-1.354a1.656 1.656 0 012.825-1.167 1.635 1.635 0 01.486 1.167v1.355h3.308a1.042 1.042 0 011.042 1.041h0v3.5h1.336a1.651 1.651 0 011.653 1.644z","fill":"none","stroke":"#5a677b","stroke-linejoin":"round","stroke-width":"1.5"}})])])
          )
        }
      }
    